import type {
  BaseEvent,
  EventOptions,
} from '@amplitude/analytics-browser/lib/esm/types';

import { getCurrWorkspaceAlias } from '../workspace';

export const track = async (
  event: string | BaseEvent,
  properties?: Record<string, any>,
  eventOptions?: EventOptions,
) => {
  if (import.meta.env.VITE_PUBLIC_ENVIRONMENT !== 'prod') return;
  const amplitude = await import('@amplitude/analytics-browser');
  let pathname = window?.location?.pathname;
  const workspaceId = getCurrWorkspaceAlias();
  pathname = pathname.replace(`/workspace/${workspaceId}`, '');

  amplitude.track(
    event,
    {
      ...(properties || {}),
      pathname: pathname,
    },
    eventOptions,
  );
};
